<div
    class="mobile-sidebar d-lg-none d-block"
    [class.mobile-expanded]="isSidebarExpanded"
    [class.mobile-collapsed]="!isSidebarExpanded"
>
    <div class="row py-3">
        <!-- logo -->
        <div class="col d-flex ms-4 my-auto">
            @if (isSidebarExpanded && (tenantId$ | async) === null) {
                <img alt="" class="logo-expanded" src="/assets/img/common/logo-lg.png" />
            }
        </div>
        @if (logoUrl) {
            <div>
                @if (isSidebarExpanded && (tenantId$ | async)) {
                    <img alt="" class="logo-expanded" [src]="logoUrl" />
                }
            </div>
        }
        @if (!logoUrl) {
            <div>
                @if (isSidebarExpanded && (tenantId$ | async)) {
                    <span class="logo-expanded text-white fw-medium text-uppercase h6">{{ companyName }}</span>
                }
                @if (!isSidebarExpanded && (tenantId$ | async)) {
                    <span class="logo-collapsed text-white fw-medium text-uppercase text-small">{{
                        companyName.substring(0, 2)
                    }}</span>
                }
            </div>
        }
        <!-- //logo -->

        <div class="col">
            <a (click)="sideNavClose()" class="text-white fs-24 float-end me-3 my-auto cursor-pointer"
                ><i class="bi bi-x"></i
            ></a>
        </div>
    </div>

    <!-- List Group -->
    <ul class="sidebar list-group mobile" [class.fade-in]="isSidebarExpanded" [class.fade-out]="!isSidebarExpanded">
        @for (
            item of (userRole$ | async) === userRoleType.APPLICATION_VIEWER ||
            (userRole$ | async) === userRoleType.TENANT_VIEWER
                ? viewRoutes
                : (tenantId$ | async) === null
                  ? tenantManageRoutes
                  : adminRoutes;
            track item.name
        ) {
            <a
                [routerLink]="item.route"
                class="list-group-item mobile"
                [routerLinkActive]="!item.hasSubMenu ? 'active' : ''"
                (click)="sideNavClose()"
            >
                <div class="d-flex w-100 justify-content-start align-items-center ps-2">
                    <i class="bi" [ngClass]="item.icon"></i>
                    <span class="menu-collapsed">{{ item.name }}</span>
                </div>
                <!-- //List Group - subMenu -->
                @if (item.hasSubMenu) {
                    <div class="dropdown-expanded mt-2">
                        @for (items of item.subMenu; track items.name) {
                            <a class="list-group-item" routerLinkActive="active" [routerLink]="items.route">
                                <div
                                    [ngClass]="{ 'ps-2': isSidebarExpanded, 'justify-content-center': !isSidebarExpanded }"
                                    class="d-flex align-self-center"
                                >
                                    <i [ngClass]="items.icon" class="bi"></i>
                                    <span class="menu-collapsed">{{ items.name }}</span>
                                </div>
                            </a>
                        }
                    </div>
                }
                <!-- //List Group - subMenu-->
            </a>
        }
        <!-- //List Group -->
    </ul>
</div>
